<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="wcrd_phn_hrs"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >WORK APPLICANT UNIT PHONE NUMBER/HOURS OF OPERATION
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <div class="mt-6 pa-4" style="color: black">
            Phone:
            <a href="tel:7753343875">775-334-3875</a>
            <br />
            Hours of Operation: Monday through Thursday 8:00 a.m. to 3:30 p.m
            <br />
            Closed for lunch between 11:00 am -12:00 pm
          </div>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "wcrd_phn_hrs",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
